import { render, staticRenderFns } from "./JobsEntity.vue?vue&type=template&id=204bc538&"
import script from "./JobsEntity.vue?vue&type=script&lang=js&"
export * from "./JobsEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports